import React from 'react';
import { Link } from '@reach/router';
import { AppPath } from 'appConstants';

type Props = {
  subscriptionRenewalDate: string;
};

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * A free trial's days left, with its upgrade link
 */
const SubjectSiteTrialBanner: React.FC<Props> = ({
  subscriptionRenewalDate,
}) => {
  const daysLeft = Math.round(
    (new Date(subscriptionRenewalDate).getTime() - Date.now()) /
      MILLISECONDS_PER_DAY
  );

  return (
    <div className="TrialBanner SubscribeBanner">
      <div className="SubBannerContainer">
        <div className="TrialDaysRemaining">
          <div className="TrialDaysRemaining">
            TRIAL {daysLeft} {daysLeft === 1 ? 'DAY' : 'DAYS'} LEFT
          </div>
        </div>
        <div className="Subscribebtn">
          <div className="BtnOne BtnSubscribe">
            <Link to={AppPath.UPGRADE_SUBSCRIPTION}>
              Upgrade To Subscription
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectSiteTrialBanner;
